import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import SpamRequestViewDialogHeader from './SpamRequestViewDialogHeader';
import api from '@/utils/apiClient';
import LoadingIcon from 'mdi-react/LoadingIcon';
import moment from 'moment';

const SpamRequestViewDialog = ({ show, onHide, id, rtl }) => {
  const [modal] = useState({
    isOpen: show,
    title: 'View Spam Request',
    hide: onHide,
  });

  const [state, setState] = useState({
    loading: true,
    spamRequest: {},
    error: '',
  });

  useEffect(() => {
    if (id) getSpamRequestById(+id);
  }, [id]);

  const getSpamRequestById = async (spamRequestId) => {
    try {
      const { data: res, isSuccess } = await api.cadsAISpamRequest.getSpamRequestById(spamRequestId);
      if (id) {
        setState({ ...state, loading: false, spamRequest: res.data, error: '' });
      } else {
        throw new Error(res?.messages?.[0] ?? 'Error while getting spam request details');
      }
    } catch ({ message }) {
      setState({ ...state, loading: false, spamRequest: {}, error: message });
      console.error(message);
    }
  };

  const { error, loading, spamRequest } = state;

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-view-dialog"
    >
      <SpamRequestViewDialogHeader modal={modal} spamRequest={spamRequest} />
      {/* spamRequest Modal Body */}
      <div style={{ padding: 15 }}>
        {loading || !!error ? (
          <>
            {loading && (
              <div className="panel__refresh position-relative" style={{ height: 75 }}>
                <LoadingIcon />
              </div>
            )}
            <div className="text-center">
              {error && (
                <div>
                  <span className="lnr lnr-cross-circle modal__title-icon error" />
                </div>
              )}
              {loading ? 'Getting Spam Request details...' : error}
            </div>
          </>
        ) : (
          <table className="project-summary__info">
            <tr>
              <th>Reported Email</th>
              <td>{spamRequest?.reportedEmail ?? '-'}</td>
            </tr>
            <tr>
              <th>Type</th>
              <td>{spamRequest?.type ?? '-'}</td>
            </tr>
            <tr>
              <th>Details</th>
              <td>{spamRequest?.details ?? '-'}</td>
            </tr>
            <tr>
              <th className="w-25">Reported Date</th>
              <td>{spamRequest?.reportedDate ? moment(spamRequest?.reportedDate).format('DD/MM/yyyy') : '-'}</td>
            </tr>
          </table>
        )}
      </div>
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(SpamRequestViewDialog);
